import { color } from "lib/theme/color";
import { size } from "lib/theme/size";
import { SxObjType } from "lib/theme/types/SxObjType.type";
import { Theme } from "@mui/material";

const sxStyles = (theme: Theme) => {
  return {
    linkedHeader: {
      p: 1.5,
      backgroundColor: theme.palette.secondary.light,
      boxShadow: "0px 0px 6px " + color.RGBA_52,
      display: "flex",
      alignItems: "center",
    },
    linkedTitle: {
      color: theme.palette.grey[400],
      typography: theme.typography.body2_semibold,
    },
    helpIcon: {
      margin: theme.spacing(-0.2, 1),
    },
    dialogTitle: {
      color: theme.palette.text.primary,
      typography: theme.typography.header4_semibold,
      paddingBottom: theme.spacing(1),
      "& .MuiTypography-root": {
        color: theme.palette.text.primary,
        typography: theme.typography.header4_semibold,
      },
    },
    dialogText: {
      color: theme.palette.grey[400],
      typography: theme.typography.body2_regular,
      marginBottom: 0,
    },
    shouldSubmitRequestDisclaimerText: {
      color: theme.palette.grey[400],
      typography: theme.typography.caption1_regular,
      margin: theme.spacing(0, 1),
      "& a": {
        color: theme.palette.primary.main,
      },
    },
    cardTopContainer: {
      display: "flex",
      position: "relative",
    },
    addToCalendarContainer: {
      position: "absolute",
      top: 0,
      right: 0,
      p: theme.spacing(2, 1, 0.5),
    },
    actionMsg: {
      color: theme.palette.grey[400],
      typography: theme.typography.caption1_regular,
      margin: theme.spacing(0, 1),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[600],
      "& .MuiSvgIcon-root": {
        fontSize: size.FONTSIZE_24,
      },
    },
    okButton: {
      borderRadius: theme.spacing(0.5),
      marginBottom: theme.spacing(1),
    },
    reminderText: {
      m: 1,
      background: theme.palette.info.light,
    },
  } satisfies SxObjType;
};

export { sxStyles };
